import React from "react";
import GeneralStrings from "../../strings/GeneralStrings.json";
import GeneralConst from "../../consts/GeneralConst";
import { Helmet } from "react-helmet";
import logo from "../../assets/logo/logo.png";
import swimlanes from "../../assets/backgrounds/swimlanes-bg.jpg";
import HomepageNavbar from "../../components/HomepageNavbar/HomepageNavbar";
import Footer from "../../components/Footer/Footer";
import "./AboutUsPage.scss";

const AboutUsPage = () => {
  const ABOUT_US_STRINGS = GeneralStrings.ABOUT_US;
  const TITLE = `${ABOUT_US_STRINGS.BANNER_HEADING} | ${GeneralConst.SITE_NAME}`;

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <div className="about-us-page">
        <HomepageNavbar transparentNavbar={false} />
        <section className="page-banner">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8 col-xl-7">
                <div className="banner-heading">
                  <h1>{ABOUT_US_STRINGS.BANNER_HEADING}</h1>
                  <p className="banner-subheading">
                    {ABOUT_US_STRINGS.BANNER_SUBTEXT}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="container">
          <div className="row about-us-content-container">
            <div className="about-us-item">
              <div className="col-sm-12 col-md-4">
                <img src={logo} className="about-img" alt="Logo" />
              </div>
              <div className="col-sm-12 col-md-8 about-item-content">
                <h3 className="heading">{ABOUT_US_STRINGS.OUR_MISSION}</h3>
                <p className="description">
                  {ABOUT_US_STRINGS.OUR_MISSION_DESCRIPTION}
                </p>
              </div>
            </div>
            <div className="about-us-item">
              <div className="col-sm-12 col-md-8 about-item-content left">
                <h3 className="heading">{ABOUT_US_STRINGS.OUR_VISION}</h3>
                <p className="description">
                  {ABOUT_US_STRINGS.OUR_VISION_DESCRIPTION}
                </p>
              </div>
              <div className="col-sm-12 col-md-4">
                <img src={swimlanes} className="swimlane-img" alt="Logo" />
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default AboutUsPage;
